// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import OPEN600 from '@/components/OPEN600.vue';
import OPEN650 from '@/components/OPEN650.vue';
import OPEN750 from '@/components/OPEN750.vue';
import OPEN850 from '@/components/OPEN850'
import ProLine550 from '@/components/ProLine550.vue';
import ProLine620 from '@/components/ProLine620.vue';
import ProLine740 from '@/components/ProLine740.vue';
import SportLine440 from '@/components/SportLine440.vue';
import SportLine480 from '@/components/SportLine480.vue';
import SportLine520 from '@/components/SportLine520.vue';
import TopLine600 from '@/components/TopLine600.vue';
import TopLine650 from '@/components/TopLine650.vue';
import TopLine850 from '@/components/TopLine850.vue';
import TopLine950 from '@/components/TopLine950.vue';





const routes = [
  { path: '/', component: OPEN600 }, // Default route
  { path: '/OPEN600', component: OPEN600 },
  { path: '/OPEN650', component: OPEN650 },
  { path: '/OPEN750', component: OPEN750 },
  { path: '/OPEN850', component: OPEN850 },
  { path: '/ProLine550', component: ProLine550 },
  { path: '/ProLine620', component: ProLine620 },
  { path: '/ProLine740', component: ProLine740 },
  { path: '/SportLine440', component: SportLine440 },
  { path: '/SportLine480', component: SportLine480 },
  { path: '/SportLine520', component: SportLine520 },
  { path: '/TopLine600', component: TopLine600 },
  { path: '/TopLine650', component: TopLine650 },
  { path: '/TopLine850', component: TopLine850 },
  { path: '/TopLine950', component: TopLine950 },

  // Add more routes for your other models
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
